import { QueryVariables } from 'features/inventory/ad-unit/components/AdUnitsTable/types/api'
import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { AD_UNIT_FOR_TABLE_FRAGMENT } from './fragment'
import { Data } from './types'

export const GET_AD_UNITS_FOR_TABLE = (
  ability: Ability,
): TypedDocumentNode<Data, QueryVariables> => gql`
  ${AD_UNIT_FOR_TABLE_FRAGMENT(ability)}

  query getAdUnitsForTable(
    $first: Int
    $last: Int
    $workspaceId: ID!
    $terms: [String!]
    $sort: AdUnitSortInput
  ) {
    adUnits(first: $first, last: $last, workspaceId: $workspaceId, terms: $terms, sort: $sort) {
      nodes {
        ...AdUnitForTableFragment
      }

      totalCount
    }
  }
`
